export default __webpack_public_path__ + "static/media/googleBooks.57dd04cf.jpg";